<p-toast></p-toast>

<div class="container-fluid title list-header">
    <h1 class="title">Gestión de Usuarios</h1>
    <button class="button create-user-button" (click)="createUser()">
        <fa-icon class="create-user-icon" [icon]="faUserPlus"></fa-icon>
        Añadir usuario
    </button>
</div>

<div class="container-fluid content-page background">
    <div class="columns is-multiline filters-container">
        <div class="column is-3">
            <div class="name-search-wrapper">
                <input
                    type="text"
                    class="input name-search"
                    [class.is-filled]="searchName"
                    placeholder="Buscar por nombre o email..."
                    [(ngModel)]="searchName"
                    (input)="onNameSearch()"
                />
                @if (searchName) {
                    <span class="name-search-clear" (click)="onNameCleared()">&#x2715;</span>
                }
            </div>
        </div>

        <div class="column is-3">
            <p-dropdown
                [options]="departments"
                [(ngModel)]="selectedDepartment"
                optionLabel="label"
                optionValue="value"
                [filter]="false"
                [showClear]="true"
                placeholder="Departamento"
                (onClear)="onDepartmentCleared()"
                (onChange)="onDepartmentSelected($event)"
                [emptyFilterMessage]="'No se encontraron resultados'"
            />
        </div>

        <div class="column is-3">
            <p-dropdown
                [options]="roles"
                [(ngModel)]="selectedRole"
                optionLabel="label"
                optionValue="value"
                [filter]="false"
                [showClear]="true"
                placeholder="Rol"
                (onChange)="onRoleChanged($event.value)"
                (onClear)="onRoleChanged()"
            />
        </div>

        <div class="column is-3">
            <p-dropdown
                [options]="statusOptions"
                [(ngModel)]="selectedStatus"
                optionLabel="label"
                optionValue="value"
                [filter]="false"
                [showClear]="true"
                placeholder="Estado"
                (onClear)="onStatusCleared()"
                (onChange)="onStatusSelected($event)"
                [emptyFilterMessage]="'No se encontraron resultados'"
            />
        </div>
    </div>

    @if (!isLoading) {
        <div class="table-wrapper" [class.is-refreshing]="isRefreshing" [attr.aria-busy]="isRefreshing">
            <app-users-table
                [configTable]="configTable"
                [hasFilters]="hasFilters"
                (clearFilters)="clearFilters()"
            ></app-users-table>
        </div>
        
        <div class="pagination-container">
            <app-pagination
                [currentPage]="currentPage"
                [totalPages]="maxPages"
                (pageChange)="onPageChange($event)"
            ></app-pagination>
        </div>
    } @else {
        <div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px;">
            <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner"/>
        </div>
    }
</div>
